"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectMediaType = exports.isOrientationPortrait = exports.selectIsTablet = exports.selectIsExtraSmall = exports.selectIsSmall = exports.selectIsMedium = exports.selectIsCompact = exports.selectOrientation = exports.makeViewportSelector = exports.selectViewport = void 0;
var reselect_1 = require("reselect");
var types_1 = require("./types");
var constants_1 = require("./constants");
var selectViewport = function (state) { return state.get(constants_1.NAME); };
exports.selectViewport = selectViewport;
function makeViewportSelector(indicator, breakpoint) {
    return reselect_1.createSelector(exports.selectViewport, function (viewport) {
        if (breakpoint) {
            return viewport[indicator][breakpoint];
        }
        return viewport[indicator];
    });
}
exports.makeViewportSelector = makeViewportSelector;
exports.selectOrientation = reselect_1.createSelector(exports.selectViewport, function (viewport) {
    return viewport.orientation;
});
exports.selectIsCompact = makeViewportSelector('lessThanOrEqual', 'medium');
exports.selectIsMedium = makeViewportSelector('lessThanOrEqual', 'medium');
exports.selectIsSmall = makeViewportSelector('lessThanOrEqual', 'small');
exports.selectIsExtraSmall = makeViewportSelector('lessThanOrEqual', 'extraSmall');
exports.selectIsTablet = reselect_1.createSelector(makeViewportSelector('greaterThan', 'medium'), makeViewportSelector('lessThanOrEqual', 'large'), function (graterMedium, lessLarge) { return graterMedium && lessLarge; });
exports.isOrientationPortrait = reselect_1.createSelector(exports.selectOrientation, function (orientation) { return orientation === types_1.Orientation.Portrait; });
exports.selectMediaType = reselect_1.createSelector(exports.selectViewport, function (viewport) { return viewport.mediaType; });
//# sourceMappingURL=selectors.js.map